"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var __1 = require("../");
var ClickAndCollectProvider = /** @class */ (function (_super) {
    __extends(ClickAndCollectProvider, _super);
    function ClickAndCollectProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClickAndCollectProvider.prototype.componentDidMount = function () {
        this.props.clickAndCollect.setProvider(this);
    };
    ClickAndCollectProvider.prototype.render = function () {
        return (React.createElement(__1.Context.Provider, { value: {
                clickAndCollect: this.props.clickAndCollect,
            } }, this.props.children));
    };
    ClickAndCollectProvider.contextType = __1.Context;
    return ClickAndCollectProvider;
}(React.Component));
exports.ClickAndCollectProvider = ClickAndCollectProvider;
//# sourceMappingURL=click-and-collect-provider.js.map